import React, {
	useEffect, useState
} from 'react';
import {useTranslation} from "react-i18next";
import StatisticsRepository from "../../../repositories/StatisticsRepository";

import {
	Card,
	CardContent, Container,
	Grid,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FormLoading from "../../../components/FormLoading";
import {DateRangeFilter} from "../../../components/DateRangeFilter";
import {format} from "date-fns";
import moment from "moment";
import GraphLinearView from "./GraphLinearView";

const DailyEventsGraph = () => {

	const today = format(new Date(), 'yyyy-MM-dd');
	const dateTo = today;
	const dateFrom = format(new Date(moment().add(-30, 'days')), 'yyyy-MM-dd');

	const repository = new StatisticsRepository();
	const {t}  = useTranslation();
	const [data, setData] = useState(null);
	const [isSearching, setIsSearching] = useState(false);
	const [filter, setFilter] = useState({ DateFrom: dateFrom, DateTo: dateTo });

	const getData = async () => {
		setIsSearching(true);
		let result = await repository.getDailyCameraEvents(filter);
		setIsSearching(false);
		setData(result.data);
	}

	useEffect(async () => {
		await getData();
	}, [filter]);

	const onUpdateFilter = (filterData) => {
		setFilter(filterData);
	}

	return (
		<Grid container>
			<Grid item xs={12}>
				<Card
				>
					<CardContent>
						<Typography gutterBottom variant="h2">
							{t('Daily events')}
						</Typography>
						{isSearching && <FormLoading />}
						<DateRangeFilter
							position={"relative"}
							value={filter.DateFrom && filter.DateTo ? { startDate: new Date(filter.DateFrom), endDate: new Date(filter.DateTo) } : null} 
							onChange={e => {  onUpdateFilter({ 'DateFrom': format(e.startDate, 'yyyy-MM-dd'), 'DateTo': format(e.endDate, 'yyyy-MM-dd') }); }} />

						{data && <GraphLinearView data={data} />}

					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default DailyEventsGraph;